var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { LoadingOutlined } from '@ant-design/icons';
import Dropdown from '@fp-suite/core-ui/src/components/Dropdown';
// const RECEIVING_TYPE = 'FltReceiving'
var SEARCH_TYPES = ['FltReceiving', 'FltBulk', 'FltPick'];
var TYPE_RANK = {
    FltReceiving: 1,
    FltBulk: 2,
    FltPick: 3
};
var OTHERS_RANK = 4;
var rankOf = function (opt) { var _a; return (_a = TYPE_RANK[opt.locationTypeEnumId || '']) !== null && _a !== void 0 ? _a : OTHERS_RANK; };
var MIN_SEARCH_LEN = 2;
var LocationSearchDropdown = function (_a) {
    var value = _a.value, isDisabled = _a.isDisabled, autoFocus = _a.autoFocus, _b = _a.suggestedLocations, suggestedLocations = _b === void 0 ? [] : _b, title = _a.title, placeholder = _a.placeholder, onSearchLocations = _a.onSearchLocations, onValidateLocation = _a.onValidateLocation, onSelectLocation = _a.onSelectLocation, onClear = _a.onClear;
    var t = useTranslation().t;
    var _c = useState(''), locationSearch = _c[0], setLocationSearch = _c[1];
    var _d = useState(false), isSearchingLocations = _d[0], setIsSearchingLocations = _d[1];
    var receivingOptions = useState([])[0];
    var _e = useState([]), searchOptions = _e[0], setSearchOptions = _e[1];
    var _f = useState(false), isValidating = _f[0], setIsValidating = _f[1];
    var _g = useState(''), entryError = _g[0], setEntryError = _g[1];
    // Accumulates every location we've loaded/validated so a picked option can
    // still render its label even when it's not in the current result set.
    var _h = useState({}), knownLocations = _h[0], setKnownLocations = _h[1];
    var mergeKnown = function (options) {
        return setKnownLocations(function (prev) {
            var next = __assign({}, prev);
            options.forEach(function (opt) {
                if (opt === null || opt === void 0 ? void 0 : opt.key)
                    next[opt.key] = opt;
            });
            return next;
        });
    };
    // Pre-load Receiving locations 
    // 
    // useEffect(() => {
    //   let cancelled = false
    //   ;(async () => {
    //     const recv = await onSearchLocations('', [RECEIVING_TYPE])
    //     if (cancelled) return
    //     setReceivingOptions(recv)
    //     mergeKnown(recv)
    //   })()
    //   return () => {
    //     cancelled = true
    //   }
    // }, [onSearchLocations])
    // Lazy search Receiving/Bulk/Pick, debounced
    useEffect(function () {
        var term = locationSearch.trim();
        if (term.length < MIN_SEARCH_LEN) {
            setSearchOptions([]);
            setIsSearchingLocations(false);
            return;
        }
        var cancelled = false;
        setIsSearchingLocations(true);
        var timer = setTimeout(function () { return __awaiter(void 0, void 0, void 0, function () {
            var res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, onSearchLocations(term, SEARCH_TYPES)];
                    case 1:
                        res = _a.sent();
                        if (cancelled)
                            return [2 /*return*/];
                        setSearchOptions(res);
                        mergeKnown(res);
                        setIsSearchingLocations(false);
                        return [2 /*return*/];
                }
            });
        }); }, 350);
        return function () {
            cancelled = true;
            clearTimeout(timer);
        };
    }, [locationSearch, onSearchLocations]);
    // Compose options. Idle shows preloaded Receiving locations + product
    // suggestions; searching shows the search results + matching suggestions.
    var locationData = useMemo(function () {
        var term = locationSearch.trim().toLowerCase();
        var suggestionKeys = new Set(suggestedLocations.map(function (s) { return s.key; }));
        var countByKey = new Map(suggestedLocations.map(function (s) { return [s.key, s.productCount || 0]; }));
        var suggestionTag = function (key) {
            var count = countByKey.get(key) || 0;
            var label = count > 0 ? count + " " + (count === 1 ? t('SKU') : t('SKUs')) + " " + t('here') : t('Suggested');
            return _jsx("span", __assign({ className: 'text-xs text-gray-400' }, { children: label }), void 0);
        };
        var matchingSuggestions = term
            ? suggestedLocations.filter(function (s) { return (s.value || '').toLowerCase().includes(term); })
            : suggestedLocations;
        var pool = term
            ? __spreadArray(__spreadArray([], searchOptions, true), matchingSuggestions, true) : __spreadArray(__spreadArray([], receivingOptions, true), matchingSuggestions, true);
        // Dedup by key (first occurrence wins), then rank-sort (stable).
        var byKey = new Map();
        pool.forEach(function (opt) {
            if ((opt === null || opt === void 0 ? void 0 : opt.key) && !byKey.has(opt.key))
                byKey.set(opt.key, opt);
        });
        var sorted = Array.from(byKey.values()).sort(function (a, b) { return rankOf(a) - rankOf(b); });
        var out = sorted.map(function (opt) { return ({
            key: opt.key,
            value: suggestionKeys.has(opt.key) ? (_jsxs("span", __assign({ className: 'flex items-center justify-between gap-2' }, { children: [_jsx("span", { children: opt.value }, void 0), suggestionTag(opt.key)] }), void 0)) : (opt.value)
        }); });
        if (value && !byKey.has(value) && knownLocations[value]) {
            out.push({ key: value, value: knownLocations[value].value });
        }
        return out;
    }, [suggestedLocations, locationSearch, searchOptions, receivingOptions, value, knownLocations, t]);
    var commitSelection = function (locationSeqId) {
        setLocationSearch('');
        setEntryError('');
        onSelectLocation(locationSeqId);
    };
    // Enter (or scanner) — use the typed value: select it if it's already an
    // option, otherwise validate it and select the resolved location.
    var handleInputKeyDown = function (event) { return __awaiter(void 0, void 0, void 0, function () {
        var term, exact, result;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (event.key !== 'Enter')
                        return [2 /*return*/];
                    term = locationSearch.trim();
                    if (!term)
                        return [2 /*return*/];
                    (_a = event.preventDefault) === null || _a === void 0 ? void 0 : _a.call(event);
                    exact = suggestedLocations.find(function (s) { return s.key.toLowerCase() === term.toLowerCase(); }) ||
                        searchOptions.find(function (s) { return s.key.toLowerCase() === term.toLowerCase(); });
                    if (exact) {
                        commitSelection(exact.key);
                        return [2 /*return*/];
                    }
                    setIsValidating(true);
                    setEntryError('');
                    return [4 /*yield*/, onValidateLocation(term)];
                case 1:
                    result = _b.sent();
                    setIsValidating(false);
                    if (result.ok && result.locationSeqId) {
                        mergeKnown([
                            {
                                key: result.locationSeqId,
                                value: result.locationType
                                    ? result.locationSeqId + " - " + result.locationType
                                    : result.locationSeqId
                            }
                        ]);
                        commitSelection(result.locationSeqId);
                    }
                    else {
                        setEntryError(result.error || 'Invalid location');
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    return (_jsxs("div", { children: [_jsx(Dropdown, { searchable: true, allowClear: true, filterOption: false, defaultActiveFirstOption: false, autoFocus: autoFocus, loading: isSearchingLocations || isValidating, notFoundContent: isSearchingLocations || isValidating
                    ? t('Checking...')
                    : locationSearch.trim()
                        ? t('No match — press Enter to use this location')
                        : t('Type or scan a location'), data: locationData, title: title, placeholder: placeholder || t('Select, search, or scan a location'), isDisabled: isDisabled, value: value || undefined, searchBoxOnChange: function (val) {
                    setLocationSearch(val || '');
                    setEntryError('');
                }, onInputKeyDown: handleInputKeyDown, onSelect: function (val) {
                    setLocationSearch('');
                    setEntryError('');
                    onSelectLocation(val);
                }, onClear: function () {
                    setLocationSearch('');
                    setEntryError('');
                    onClear === null || onClear === void 0 ? void 0 : onClear();
                } }, void 0), isValidating && (_jsxs("p", __assign({ className: 'mt-1 flex items-center gap-1 text-xs text-gray-400' }, { children: [_jsx(LoadingOutlined, {}, void 0), " ", t('Checking...')] }), void 0)), !isValidating && entryError && (_jsx("p", __assign({ className: 'mt-1 text-xs text-red-600' }, { children: t(entryError) }), void 0))] }, void 0));
};
export default LocationSearchDropdown;
